/*-------------------- Define Routes here for school --------------------*/
export const school = 'school'
export const school_id = 'view-slug'
